module.exports = __webpack_public_path__ + "static/030-fe1cc8c94f6919e5a4ecad7af7af61b2.jpg";